<template>
  <VDialogV3
    closable
    width="500px"
    @submit="submit"
    :loading="false"
  >
    <template #header>
      Отказ от участия
    </template>

    <VCheckboxGroup
      v-model="localParticipationDetailProduct.refusalReasons"
      layout="vertical"
      checkbox-layout="vertical"
      :options="$core.dictionaries.tenderRefusalReasons.toArray()"
      option-label="name"
      @input="onRefusalReasonInput"
    />

    <VTextarea
      v-show="showTextareaRefusalReason"
      ref="textareaRef"
      v-model="localParticipationDetailProduct.refusalReasonCustomText"
    />
  </VDialogV3>
</template>

<style lang="scss" src="./TenderRefuseDialog.scss"/>

<script lang="ts">
import ParticipationDetailProduct from "@/domains/ParticipationDetailProduct/ParticipationDetailProduct";
import Core                       from "@/core/Core";
import TendersService             from '@/domains/Tenders/TendersService';

export default defineComponent({
  name:   'TenderRefuseDialog',

  props: {
    /**
     * Участия текущего поставщика в тендере, по которым он вправе играть.
     * Их несколько: по одному на каждое разрешение на поставку. Отказ у
     * поставщика один на тендер, поэтому форма правит первое, а сохраняются
     * все. Исключённые из торгов разрешения сюда не попадают.
     */
    participationDetailProducts: {
      type:    Array as PropType<ParticipationDetailProduct[]>,
      default: () => [],
    }
  },

  data() {
    const localParticipationDetailProducts = Core.utils.cloneDeep(this.participationDetailProducts);

    /** Форма работает с первым участием — состояние у них общее. */
    const localParticipationDetailProduct = localParticipationDetailProducts[0];

    /** Если диалог был открыт, значит пользователь уже отказался */
    localParticipationDetailProduct.setParticipation(false);

    return {
      localParticipationDetailProducts,
      localParticipationDetailProduct
    };
  },

  computed: {
    showTextareaRefusalReason() {
      /** Если причина есть, и пользователь выбрал Другое, то нужно показывать поле */
      if (
        Core.utils.isNotEmptyArray(this.localParticipationDetailProduct.refusalReasons)
        && this.localParticipationDetailProduct.refusalReasons
          .find(item => item.id === 2)
      ) {
        return true;
      }

      return false;
    },
  },

  methods: {
    async submit() {
      /** Правили первое участие, а сохраняем все: отказ у поставщика один
       *  на тендер, сколько бы разрешений у него ни было. Исключённые из
       *  торгов сюда не приходят — их отсекает геттер тендера. */
      for (const participationDetailProduct of this.localParticipationDetailProducts) {
        participationDetailProduct.setParticipation(false);
        participationDetailProduct.refusalReasons          = this.localParticipationDetailProduct.refusalReasons;
        participationDetailProduct.refusalReasonCustomText = this.localParticipationDetailProduct.refusalReasonCustomText;

        await TendersService.updateParticipation(participationDetailProduct);

        this.$core.dialogs.TenderRefuseDialog.resolve();
      }

    },

    onRefusalReasonInput(value) {
      /** Если пользователь выбрал заполнить кастомную причину,
       * то нужно установить фокус на textarea */
      if (!this.isRefusalReasonsIncludesCustomReason(value)) return;

      this.$nextTick()
        .then(() => {
          const textareaEl = this.$refs.textareaRef.$el;

          if (textareaEl) {
            textareaEl
              .querySelector('Textarea')
              .focus();
          }
        });
    },

    isRefusalReasonsIncludesCustomReason(refusalReasons) {
      return Boolean(
        refusalReasons.find(_reason => _reason.id === 2 && _reason.name === 'Другое')
      );
    }
  }
});
</script>
